<div class="mct-flex mct-row mct-justify-between mct-items-start"  >
  <h4>
    {{ 'profiles.view.recent-contacts.label' | translate | titlecase }}&nbsp;&nbsp;
    <span class="recent-contact-count">
      ({{ contacts.TotalCount }}&nbsp;{{ 'profiles.view.recent-contacts.in-90-days' | translate }})
    </span>
  </h4>
  <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-27"   >
    <a *ngIf="profileContactsTabFullAccess" (click)="addAContactClick()">{{ 'profiles.view.recent-contacts.add-a-contact' | translate | titlecase }}</a>
    <a [routerLink]="['/profile', profileId, 'contacts']" class="">
      {{ 'profiles.view.recent-contacts.manage-all' | translate | titlecase }}
      <i class="pi pi-angle-double-right"></i>
    </a>
  </div>
</div>
<div *ngFor="let contact of contacts.Result" class="contact-container" #contactsContainer>
  <div class="contact-body">
    <div class="contact-body-row mct-flex mct-row" >
      <div class="card-field-label">{{ 'profiles.view.recent-contacts.contacted' | translate | titlecase }}</div>
      <div class="contact-row-value contacted-name">{{ contact.TalkedWith }}</div>
      <div class="contact-date">{{ contact.ContactDate | date: 'shortDate' }}</div>
    </div>
    <div class="contact-body-row mct-flex mct-row" >
      <div class="card-field-label">{{ 'profiles.view.recent-contacts.subject' | translate | titlecase }}</div>
      <div class="contact-row-value">{{ contact.Subject }}</div>
    </div>
    <div class="contact-body-row mct-flex mct-row" >
      <div class="card-field-label">{{ 'profiles.view.recent-contacts.description' | translate | titlecase }}</div>
      <div class="contact-body-value description" #contactDescr>{{ contact.trimmedDescr ? contact.trimmedDescr : contact.Descr }}</div>
    </div>
  </div>
  <div class="contact-footer mct-flex mct-row" >
    <div class="card-field-label">&nbsp;</div>
    <div class="contact-footer-content-wrapper mct-flex mct-row mct-justify-between mct-items-stretch"  >
      <div class="contact-type-field mct-flex mct-row" >
        <div class="contact-type-label">{{ 'profiles.view.recent-contacts.type' | translate | titlecase }}</div>
        <div>{{ contact.ContactType }}</div>
      </div>
      <div class="contacted-by mct-flex mct-row" >
        <div class="contacted-by-label">{{ 'profiles.view.recent-contacts.by' | translate | titlecase }}</div>
        <div>{{ contact.Contactee }}</div>
      </div>
    </div>
  </div>
</div>
<div style="font-weight: bold;">
  <wl-paging-controls #pagingControls [pagedResult]="contacts" (pagingEvent)="onPagingEvent($event)"></wl-paging-controls>
</div>

<wl-profile-contact-edit (submitClicked)="contactSubmitClicked($event)"></wl-profile-contact-edit>
